/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import ReferenceEntry, { DisplayFromFHIRReference } from "./ReferenceEntry";
import { DateTimeEntry, getDateTimeDisplay } from "./PeriodEntry";
import CodeableConceptEntry, { DisplayFromFHIRCodeableConcept } from "./CodeableConceptEntry";
import ExpandToAddOrEdit from "../components/ExpandToAddOrEdit";

const DisplayFromFHIRAttester = ({ attester, containedResourceDictionary = {} }) => {
  if (attester) {
    if (Array.isArray(attester) || typeof attester !== "object") {
      return <>[ERROR: Attester data not interpretable.]</>;
    }
    return <div style={{ marginLeft: "24px" }}>
      {attester.mode && <span><b>Mode: </b><DisplayFromFHIRCodeableConcept codeableConcept={attester.mode} /></span>}
      {attester.time && <p><b>Date/Time: </b>{getDateTimeDisplay(attester.time)} </p>}
      {attester.party && <div><b>Party: </b><DisplayFromFHIRReference reference={attester.party}
        containedResourceJson={attester.party.reference && containedResourceDictionary[attester.party.reference]} /></div>}
    </div>
  } else {
    return <></>
  }
}

const attesterResourceTypes = ['Practitioner', 'PractitionerRole', 'Organization', 'Patient', 'RelatedPerson'];
const limitedAttesterResourceTypes = ['Practitioner', 'Organization'];
const AttesterEntry = ({ elementName, fieldLabel, startingValue, setResourceState, dataEntryStyle,
  startCollapsed, containedResourceDictionary = {} }) => {

  const [attesterState, setAttesterState] = useState({});
  const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

  useEffect(() => {
    let startingAttester = { "mode": "", "time": "", "party": "" };
    if (startingValue) {
      if (startingValue.extension) { startingAttester.extension = startingValue.extension; }
      if (startingValue.mode) { startingAttester.mode = startingValue.mode; }
      if (startingValue.time) { startingAttester.time = startingValue.time; }
      if (startingValue.party) { startingAttester.party = startingValue.party; }
    }
    setAttesterState(JSON.parse(JSON.stringify(startingAttester)));
  }, []);

  useEffect((() => {
    if (Object.keys(attesterState).length) {
      let newAttester = {};
      if (attesterState.extension) { newAttester.extension = attesterState.extension; }
      if (attesterState.mode) { newAttester.mode = attesterState.mode; }
      if (attesterState.time) { newAttester.time = attesterState.time; }
      if (attesterState.party && Object.keys(attesterState.party).length > 0) {
        newAttester.party = attesterState.party;
      }
      if (Object.keys(newAttester).length === 0) {
        newAttester = null;
      }
      setResourceState(prevState => { return { ...prevState, [elementName]: newAttester } });
    }
  }), [attesterState]);

  if (startCollapsedState) {
    return <>
      <div>
        <b>{fieldLabel}: </b>
        {startingValue && <DisplayFromFHIRAttester attester={startingValue}
          containedResourceDictionary={containedResourceDictionary} />}
        &nbsp;&nbsp;
        <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
      </div>
    </>
  } else if (Object.keys(attesterState).length > 0) {
    return <>
      <p style={{ marginBottom: "2px" }}><b>{fieldLabel}: </b></p>
      <div style={{ marginLeft: "24px" }}>
        <CodeableConceptEntry elementName='mode' fieldLabel='Mode (e.g. reviewer, endorser, editor)'
          codeableConceptLevelValueSet={[
            {
              "coding": [{ system: "http://hl7.org/fhir/contributor-role", code: "author", display: "Author/Creator" }]
            },
            {
              "coding": [{ system: "http://hl7.org/fhir/contributor-role", code: "recorder", display: "Recorder" }]
            },
            {
              "coding": [{ system: "http://hl7.org/fhir/contributor-role", code: "reviewer", display: "Reviewer" }]
            },
            {
              "coding": [{ system: "http://hl7.org/fhir/contributor-role", code: "endorser", display: "Endorser" }]
            },
            {
              "coding": [{ system: "http://hl7.org/fhir/contributor-role", code: "editor", display: "Editor" }]
            },
            {
              "coding": [{ system: "http://hl7.org/fhir/contributor-role", code: "informant", display: "Informant" }]
            },
            {
              "coding": [{ system: "http://hl7.org/fhir/contributor-role", code: "funder", display: "Funder" }]
            },
            {
              "coding": [{ system: "http://hl7.org/fhir/contributor-role", code: "publisher", display: "Publisher" }]
            }
          ]}
          startingValue={attesterState.mode} setResourceState={setAttesterState} />
        <DateTimeEntry elementName='time'
          fieldLabel='Date/Time' startingValue={attesterState.time} setResourceState={setAttesterState} />
        <ReferenceEntry elementName='party' fieldLabel={attesterState.mode?.display || "Contributor"}
          dataEntryStyle={dataEntryStyle}
          containedResourceDictionary={containedResourceDictionary}
          referencedResourceTypes={dataEntryStyle === "humanAuthor" ? limitedAttesterResourceTypes : attesterResourceTypes}
          enableCreation={true}
          startingValue={attesterState.party} setResourceState={setAttesterState} />
      </div>
    </>
  }
}

export default AttesterEntry;
export { DisplayFromFHIRAttester };